// import * as contentful from "contentful";

// export const contentfulClient = contentful.createClient({
//   space: process.env.REACT_APP_CONTENT_SPACE_ID || "",
//   accessToken: process.env.REACT_APP_CONTENT_ACCESS_TOKEN || "",
// });

// export const previewClient = contentful.createClient({
//   host: "preview.contentful.com",
//   space: process.env.REACT_APP_CONTENT_SPACE_ID || "",
//   accessToken: process.env.REACT_APP_CONTENT_PREVIEW_TOKEN!,
// });

import * as contentful from "contentful";

const space = process.env.REACT_APP_CONTENT_SPACE_ID;
const deliveryToken = process.env.REACT_APP_CONTENT_ACCESS_TOKEN;
const previewToken = process.env.REACT_APP_CONTENT_PREVIEW_TOKEN;

// Only create the client if all required envs are available
export const contentfulClient =
  space && deliveryToken
    ? contentful.createClient({
        space,
        accessToken: deliveryToken,
      })
    : null;

export const previewClient =
  space && previewToken
    ? contentful.createClient({
        host: "preview.contentful.com",
        space,
        accessToken: previewToken,
      })
    : null;
